module.exports = __webpack_public_path__ + "static/media/94.63ae984f.jpg";